// Payroll Saga
import { all, call, fork, put, takeEvery, takeLatest } from "redux-saga/effects";

import {
  GET_PAYROLL_RUN_LIST,
  GET_PAYROLL_RUN_DATA,
  PAYROLL_CREATE_PREVIEW,
  PAYROLL_CREATE_PREVIEW_PDF,
  PAYROLL_CREATE,
  PAYROLL_UPDATE,
  PAYROLL_DELETE,
  GET_PAYROLL_PAYSLIP_DATA,
  GET_PAYROLL_PAYSLIP_PDF,
  GET_PAYROLL_HMRC_LIST,
  PAYROLL_HMRC_SUBMIT,
  PAYROLL_HMRC_SETTINGS_SAVE,
  GET_PAYROLL_HMRC_SETTINGS_DATA,
} from "./actionType";

import {
  getPayrollRunListSuccess,
  getPayrollRunListFailure,
  getPayrollRunDataSuccess,
  getPayrollRunDataFailure,
  payrollCreatePreviewSuccess,
  payrollCreatePreviewFailure,
  payrollCreatePreviewPdfSuccess,
  payrollCreatePreviewPdfFailure,
  payrollCreateSuccess,
  payrollCreateFailure,
  payrollUpdateSuccess,
  payrollUpdateFailure,
  payrollDeleteSuccess,
  payrollDeleteFailure,
  getPayrollPayslipDataSuccess,
  getPayrollPayslipDataFailure,
  getPayrollPayslipPdfSuccess,
  getPayrollPayslipPdfFailure,
  getPayrollHmrcListSuccess,
  getPayrollHmrcListFailure,
  payrollHmrcSubmitSuccess,
  payrollHmrcSubmitFailure,
  payrollHmrcSettingsSaveSuccess,
  payrollHmrcSettingsSaveFailure,
  getPayrollHmrcSettingsDataSuccess,
  getPayrollHmrcSettingsDataFailure,
} from "./action";

import {
  getPayrollRunListApiCall,
  getPayrollRunDataApiCall,
  postPayrollCreatePreviewApiCall,
  postPayrollCreatePreviewPdfApiCall,
  postPayrollCreateApiCall,
  putPayrollUpdateApiCall,
  deletePayrollApiCall,
  getPayrollPayslipDataApiCall,
  getPayrollPayslipPdfApiCall,
  getPayrollHmrcListApiCall,
  postPayrollHmrcSubmitApiCall,
  postPayrollHmrcSettingsApiCall,
  getPayrollHmrcSettingsDataApiCall,
} from "../../helpers/fakebackend_helper";

function* getPayrollRunListSaga({ payload }) {
  try {
    const response = yield call(getPayrollRunListApiCall, payload);
    yield put(getPayrollRunListSuccess(response));
  } catch (error) {
    yield put(getPayrollRunListFailure(error));
  }
}

function* getPayrollRunDataSaga({ payload }) {
  try {
    const response = yield call(getPayrollRunDataApiCall, payload);
    yield put(getPayrollRunDataSuccess(response));
  } catch (error) {
    yield put(getPayrollRunDataFailure(error));
  }
}

function* payrollCreatePreviewSaga({ payload }) {
  try {
    const response = yield call(postPayrollCreatePreviewApiCall, payload);
    yield put(payrollCreatePreviewSuccess(response));
  } catch (error) {
    yield put(payrollCreatePreviewFailure(error));
  }
}

function* payrollCreatePreviewPdfSaga({ payload }) {
  try {
    const response = yield call(postPayrollCreatePreviewPdfApiCall, payload);
    yield put(payrollCreatePreviewPdfSuccess(response));
  } catch (error) {
    yield put(payrollCreatePreviewPdfFailure(error));
  }
}

function* payrollCreateSaga({ payload }) {
  try {
    const response = yield call(postPayrollCreateApiCall, payload);
    yield put(payrollCreateSuccess(response));
  } catch (error) {
    yield put(payrollCreateFailure(error));
  }
}

function* payrollUpdateSaga({ payload }) {
  try {
    const response = yield call(putPayrollUpdateApiCall, payload);
    yield put(payrollUpdateSuccess(response));
  } catch (error) {
    yield put(payrollUpdateFailure(error));
  }
}

function* payrollDeleteSaga({ payload }) {
  try {
    const response = yield call(deletePayrollApiCall, payload);
    yield put(payrollDeleteSuccess(response));
  } catch (error) {
    yield put(payrollDeleteFailure(error));
  }
}

function* getPayrollPayslipDataSaga({ payload }) {
  try {
    const response = yield call(getPayrollPayslipDataApiCall, payload);
    yield put(getPayrollPayslipDataSuccess(response));
  } catch (error) {
    yield put(getPayrollPayslipDataFailure(error));
  }
}

function* getPayrollPayslipPdfSaga({ payload }) {
  try {
    const response = yield call(getPayrollPayslipPdfApiCall, payload);
    yield put(getPayrollPayslipPdfSuccess(response));
  } catch (error) {
    yield put(getPayrollPayslipPdfFailure(error));
  }
}

function* getPayrollHmrcListSaga({ payload }) {
  try {
    const response = yield call(getPayrollHmrcListApiCall, payload);
    yield put(getPayrollHmrcListSuccess(response));
  } catch (error) {
    yield put(getPayrollHmrcListFailure(error));
  }
}

function* payrollHmrcSubmitSaga({ payload }) {
  try {
    const response = yield call(postPayrollHmrcSubmitApiCall, payload);
    yield put(payrollHmrcSubmitSuccess(response));
  } catch (error) {
    yield put(payrollHmrcSubmitFailure(error));
  }
}

function* payrollHmrcSettingsSaveSaga({ payload }) {
  try {
    const response = yield call(postPayrollHmrcSettingsApiCall, payload);
    yield put(payrollHmrcSettingsSaveSuccess(response));
  } catch (error) {
    yield put(payrollHmrcSettingsSaveFailure(error));
  }
}

function* getPayrollHmrcSettingsDataSaga({ payload }) {
  try {
    const response = yield call(getPayrollHmrcSettingsDataApiCall, payload);
    yield put(getPayrollHmrcSettingsDataSuccess(response));
  } catch (error) {
    yield put(getPayrollHmrcSettingsDataFailure(error));
  }
}

// Watchers
function* watchGetPayrollRunListSaga() {
  yield takeEvery(GET_PAYROLL_RUN_LIST, getPayrollRunListSaga);
}
function* watchGetPayrollRunDataSaga() {
  yield takeEvery(GET_PAYROLL_RUN_DATA, getPayrollRunDataSaga);
}
function* watchPayrollCreatePreviewSaga() {
  // takeLatest so rapid edits cancel stale in-flight previews
  yield takeLatest(PAYROLL_CREATE_PREVIEW, payrollCreatePreviewSaga);
}
function* watchPayrollCreatePreviewPdfSaga() {
  yield takeLatest(PAYROLL_CREATE_PREVIEW_PDF, payrollCreatePreviewPdfSaga);
}
function* watchPayrollCreateSaga() {
  yield takeEvery(PAYROLL_CREATE, payrollCreateSaga);
}
function* watchPayrollUpdateSaga() {
  yield takeEvery(PAYROLL_UPDATE, payrollUpdateSaga);
}
function* watchPayrollDeleteSaga() {
  yield takeEvery(PAYROLL_DELETE, payrollDeleteSaga);
}
function* watchGetPayrollPayslipDataSaga() {
  yield takeEvery(GET_PAYROLL_PAYSLIP_DATA, getPayrollPayslipDataSaga);
}
function* watchGetPayrollPayslipPdfSaga() {
  yield takeEvery(GET_PAYROLL_PAYSLIP_PDF, getPayrollPayslipPdfSaga);
}
function* watchGetPayrollHmrcListSaga() {
  yield takeEvery(GET_PAYROLL_HMRC_LIST, getPayrollHmrcListSaga);
}
function* watchPayrollHmrcSubmitSaga() {
  yield takeEvery(PAYROLL_HMRC_SUBMIT, payrollHmrcSubmitSaga);
}
function* watchPayrollHmrcSettingsSaveSaga() {
  yield takeEvery(PAYROLL_HMRC_SETTINGS_SAVE, payrollHmrcSettingsSaveSaga);
}
function* watchGetPayrollHmrcSettingsDataSaga() {
  yield takeEvery(
    GET_PAYROLL_HMRC_SETTINGS_DATA,
    getPayrollHmrcSettingsDataSaga
  );
}

export default function* payrollSaga() {
  yield all([
    fork(watchGetPayrollRunListSaga),
    fork(watchGetPayrollRunDataSaga),
    fork(watchPayrollCreatePreviewSaga),
    fork(watchPayrollCreatePreviewPdfSaga),
    fork(watchPayrollCreateSaga),
    fork(watchPayrollUpdateSaga),
    fork(watchPayrollDeleteSaga),
    fork(watchGetPayrollPayslipDataSaga),
    fork(watchGetPayrollPayslipPdfSaga),
    fork(watchGetPayrollHmrcListSaga),
    fork(watchPayrollHmrcSubmitSaga),
    fork(watchPayrollHmrcSettingsSaveSaga),
    fork(watchGetPayrollHmrcSettingsDataSaga),
  ]);
}
